import Paragraph from 'components/Paragraph';
import RoundedButton from 'components/RoundedButton';
import Strong from 'components/Strong';
import { format } from 'date-fns';
import React from 'react';

const CSS = require('./ConfirmTransfer.module.scss');

type ConfirmTransferProps = {
  dateTime: string;
  onConfirm: () => void;
  onCancel: () => void;
};

function ConfirmTransfer({
  dateTime,
  onConfirm,
  onCancel,
}: ConfirmTransferProps) {
  const dateTimeObject = new Date(dateTime);

  return (
    <div className={CSS.ConfirmTransfer}>
      <h1 className={CSS.Title}>Accept this transfer</h1>
      <Paragraph className={CSS.Paragraph}>
        <Strong weight="medium">
          Once you accept this booking, it will be immediately added to your
          agenda.
        </Strong>
        &nbsp; After this, you will be able to contact the guest and see their
        details.
      </Paragraph>
      <Paragraph className={CSS.Paragraph}>
        <Strong weight="medium">
          Sure you can be available to host this transferred experience on&nbsp;
          <span className={CSS.Pink}>
            {format(dateTimeObject, 'cccc MMMM do, yyyy')}
          </span>{' '}
          at&nbsp;
          <span className={CSS.Pink}>{format(dateTimeObject, 'HH:mm')}</span>?
        </Strong>
      </Paragraph>
      <RoundedButton className={CSS.Button} size="S" onClick={onConfirm}>
        Yes, transfer this booking to me
      </RoundedButton>
      <RoundedButton
        className={CSS.Button}
        size="S"
        inverted
        onClick={onCancel}
      >
        Cancel
      </RoundedButton>
    </div>
  );
}

export default ConfirmTransfer;
